<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <h1>{{ $t("blog.authors") }}</h1>
      <div class="flex md:flex-row flex-col max-w-4xl md:w-full md:mx-auto mt-6 mb-12 mx-4">
        <div class="p-quote-blog-intro-text text-left md:text-center" v-html="$t('blog.authorIntroText')"></div>
      </div>

      <div class="bg-primary/5 border-primary-light border-t py-8">
        <NuxtLayout name="center">
          <div class="flex flex-wrap ease-in duration-300">
            <TransitionRoot
              appear
              v-for="(allAuthor, index) in allAuthors"
              :key="index"
              :show="true"
              class="author-card basis-full md:basis-1/2 lg:basis-1/3 mb-8"
              enter="transition-opacity duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="transition-opacity duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <BlogAuthorCard :data="allAuthor"></BlogAuthorCard>
            </TransitionRoot>
          </div>
          <div class="flex justify-center my-16 font-bold text-secondary">
            <div>{{ errorMessage }}</div>
            <button
              class="border rounded px-10 py-1 border-secondary"
              @click="loadMore"
              v-if="!pending && !errorMessage && allAuthors.length < totalAuthors"
            >
              {{ $t("blog.pagination") }}
            </button>
          </div>
        </NuxtLayout>
      </div>
    </div>
  </div>
</template>

<script setup>
import { TransitionRoot } from "@headlessui/vue";
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();
const site = () => globalStore.siteCurrentLocale;
defineI18nRoute({
  locales: ["en", "es"],
});
const paged = shallowRef(1);
const blogsPerPage = shallowRef(3);
const allAuthors = ref([]);
const totalAuthors = shallowRef(0);

const queryString = computed(() => {
  let values = `?paged=${paged.value}&limit=${globalStore.siteSettings.blogs_per_page}`;
  values += `&orderby=display_name&order=ASC`;
  return values;
});
const { data: authorLists, pending, error: errorMessage, refresh } = await useAuthorList(queryString, site);
if (import.meta.client && !authorLists.value?.data) await refresh();
watch(
  authorLists,
  () => {
    (allAuthors.value =
      authorLists.value?.data?.length > 0 ? [...allAuthors.value, ...authorLists.value.data] : allAuthors.value),
      (totalAuthors.value = authorLists.value?.total ?? 0);
  },
  { immediate: true }
);
watch(
  () => queryString.value,
  () => {
    errorMessage.value = "";
    refresh();
  }
);

const isShowing = ref(true);
function loadMore() {
  paged.value++;
}

useBlogMetaTitles(null, { alternates: true });
const breadcrumbs = getBreadcrumbs("blog-authors");
</script>

<style scoped>
.author-card:nth-child(even) {
  @apply md:pl-4 lg:pl-0;
}
.author-card:nth-child(odd) {
  @apply md:pr-4 lg:pr-0;
}
.author-card:nth-child(3n + 2) {
  @apply lg:px-4;
}
.author-card:nth-child(3n + 1) {
  @apply lg:pr-8;
}
.author-card:nth-child(3n) {
  @apply lg:pl-8;
}
</style>
